import { scheduleMicrotask } from './utils.esm.js';

function createNotifyManager() {
  var queue = [];
  var transactions = 0;

  var notifyFn = function notifyFn(callback) {
    callback();
  };

  var batchNotifyFn = function batchNotifyFn(callback) {
    callback();
  };

  var batch = function batch(callback) {
    var result;
    transactions++;

    try {
      result = callback();
    } finally {
      transactions--;

      if (!transactions) {
        flush();
      }
    }

    return result;
  };

  var schedule = function schedule(callback) {
    if (transactions) {
      queue.push(callback);
    } else {
      scheduleMicrotask(function () {
        notifyFn(callback);
      });
    }
  };
  /**
   * All calls to the wrapped function will be batched.
   */


  var batchCalls = function batchCalls(callback) {
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      schedule(function () {
        callback.apply(void 0, args);
      });
    };
  };

  var flush = function flush() {
    var originalQueue = queue;
    queue = [];

    if (originalQueue.length) {
      scheduleMicrotask(function () {
        batchNotifyFn(function () {
          originalQueue.forEach(function (callback) {
            notifyFn(callback);
          });
        });
      });
    }
  };
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */


  var setNotifyFunction = function setNotifyFunction(fn) {
    notifyFn = fn;
  };
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */


  var setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
    batchNotifyFn = fn;
  };

  return {
    batch: batch,
    batchCalls: batchCalls,
    schedule: schedule,
    setNotifyFunction: setNotifyFunction,
    setBatchNotifyFunction: setBatchNotifyFunction
  };
} // SINGLETON


var notifyManager = createNotifyManager();
export { createNotifyManager, notifyManager };